export function isInvalidRoutePath(path: string): boolean {
  return path === "/undefined" || path.includes("/undefined");
}
